import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import type { DropdownItemBase } from '@/components/Autocomplete/autocomplete.types';
import { FormAutocompleteField } from '@/components/Form/FormAutocompleteField/FormAutocompleteField';
import { Country, EntityType } from '@/core/graphql/generated/types';

import type { NewEntityCountryIdValuesIn } from '../_schemas/NewEntityCountryId.validation';
import { DcrFormController } from '../DcrFormController/DcrFormController';

type Option = Pick<DropdownItemBase, 'id' | 'name'>;

type Props = {
	entityType: EntityType;
	options: Country[];
};

export const PickCountryModal = ({ entityType, options }: Props) => {
	const { t } = useTranslation();
	const {
		control,
		formState: { dirtyFields }
	} = useFormContext<NewEntityCountryIdValuesIn>();

	return (
		<Box
			display={'flex'}
			flexDirection={'column'}
			gap={2}
			p={2}
			alignItems={'center'}
			justifyContent={'center'}
			width={'100%'}
		>
			<Typography variant='h6' component='h2' mb={1.5}>
				{entityType === EntityType.Hcp
					? t("What is the HCP's country?")
					: t("What is the HCO's country?")}
			</Typography>
			<DcrFormController
				name='newEntityCountryId'
				control={control}
				filterable={false}
				customSx={{
					width: '100%'
				}}
				render={({ field, fieldState }) => (
					<FormAutocompleteField<Option>
						label={''}
						hideLabel
						placeholder={t('Select')}
						id='newEntityCountryId'
						name={field.name}
						section={
							entityType === EntityType.Hcp ? 'professional' : 'organizational'
						}
						options={options}
						defaultValue={(field.value ?? '') as string}
						indicateError={fieldState.error ? true : false}
						isDirty={dirtyFields.newEntityCountryId}
						handleOnDropdownItemSelect={item => {
							const option = options?.find(opt => opt.id === item?.id);

							field.onChange(item?.id ?? option?.name ?? '');
						}}
					/>
				)}
			/>
		</Box>
	);
};
